import { FlexibleBlockProps, FlexibleBlockTemplate } from '@nx-frontend/shared/types';
import { convertInfoCardBlockView } from './templates/template-info-card';
import { convertTimelineBlockView } from './templates/template-timeline';

interface ConvertFlexibleBlockViewProps {
  block: FlexibleBlockProps;
  template: FlexibleBlockTemplate;
}

export const convertFlexibleBlockView = ({ block, template }: ConvertFlexibleBlockViewProps): FlexibleBlockProps => {
  if (template.type === 'timeline') {
    return convertTimelineBlockView(block, template);
  }
  if (template.type === 'info-card') {
    return convertInfoCardBlockView(block, template);
  }
  return { ...block, template };
};
